import { LegalPage, H2, P, useLegalSeo } from "../components/site/Legal";
import { COMPANY } from "../data/site";
import { useSiteConfig } from "../components/site/SiteConfig";

const Row = ({ k, v, id }) => (
  <div className="grid sm:grid-cols-[260px,1fr] gap-1 sm:gap-6 py-3 border-b border-navy/10">
    <dt className="font-semibold text-navy">{k}</dt><dd className="text-slate-700" data-testid={id}>{v}</dd>
  </div>
);

export default function MentionsLegales() {
  useLegalSeo("Mentions légales", "Mentions légales du site Habitalys : éditeur, immatriculation, directeur de la publication, hébergeur.");
  const cfg = useSiteConfig();
  return (
    <LegalPage title="Mentions légales" updated="octobre 2026" testid="mentions-legales-page">
      <H2>Éditeur du site</H2>
      <dl>
        <Row k="Raison sociale" v="Habitalys" id="ml-raison-sociale" />
        <Row k="Forme juridique" v={`SAS (${COMPANY.form})`} id="ml-forme" />
        <Row k="Capital social" v={COMPANY.capital} id="ml-capital" />
        <Row k="Siège social" v={`${COMPANY.street}, ${COMPANY.city}`} id="ml-siege" />
        <Row k="Immatriculation" v={COMPANY.rcs} id="ml-rcs" />
        <Row k="SIREN" v={COMPANY.siren} id="ml-siren" />
        <Row k="SIRET (siège)" v={COMPANY.siret} id="ml-siret" />
        <Row k="N° TVA intracommunautaire" v={COMPANY.tva} id="ml-tva" />
        <Row k="EUID" v={COMPANY.euid} id="ml-euid" />
        <Row k="Code NAF / APE" v={COMPANY.naf} id="ml-naf" />
        <Row k="Date d'immatriculation" v={COMPANY.created} id="ml-creation" />
        <Row k="Président" v={COMPANY.president} id="ml-president" />
        <Row k="Directeur de la publication" v={COMPANY.president} id="ml-directeur-publication" />
        <Row k="Contact" v={COMPANY.email} id="ml-email" />
        {cfg.phone && <Row k="Téléphone" v={cfg.phone} id="ml-phone" />}
      </dl>
      <H2>Hébergeur</H2>
      <dl>
        <Row k="Hébergeur" v={cfg.host_name || "—"} id="ml-hebergeur" />
        {cfg.host_address && <Row k="Coordonnées" v={cfg.host_address} id="ml-hebergeur-adresse" />}
      </dl>
      <H2>Activité</H2>
      <P>Habitalys exerce une activité de conseil et d'assistance à maîtrise d'ouvrage (AMO) dans les domaines de l'adaptation, de la sécurisation et de la rénovation énergétique des logements. Habitalys n'exécute pas de travaux : ceux-ci sont réalisés par des entreprises tierces qualifiées et assurées, sous leur propre responsabilité.</P>
      <H2>Propriété intellectuelle</H2>
      <P>L'ensemble des contenus du site (textes, visuels, logo, mise en page) est protégé par le droit de la propriété intellectuelle. Toute reproduction ou représentation, totale ou partielle, sans autorisation écrite préalable d'Habitalys est interdite.</P>
      <H2>Informations sur les aides</H2>
      <P>Les informations relatives aux aides publiques sont fournies à titre indicatif, sur la base des règles connues à la date de publication. Les montants sont indicatifs, sous réserve d'éligibilité et des règles en vigueur ; seule la décision des organismes instructeurs fait foi.</P>
      <H2>Responsabilité</H2>
      <P>Habitalys s'efforce d'assurer l'exactitude des informations publiées mais ne saurait être tenue responsable des erreurs, omissions ou d'une indisponibilité du site. Les liens vers des sites tiers n'engagent pas la responsabilité d'Habitalys.</P>
      <H2>Données personnelles</H2>
      <P>Le traitement des données collectées via le site est décrit dans notre politique de confidentialité.</P>
    </LegalPage>
  );
}
